import type { DocumentV3 } from '@docgen/schema';

/**
 * The browser title of a proposal's print view. Chromium writes the page's
 * title into a PDF it prints as the document's own title, and the Save as PDF
 * dialog offers it as the file name. Left as the app's title, every proposal
 * PDF was called "Portal Admin | Best Corporate Events". Pure.
 */

const PRINT_TITLE_PREFIX = 'Proposal for';
const PRINT_TITLE_FALLBACK = 'Proposal';

function text(value: unknown): string {
  return typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
}

/**
 * "Proposal for <client>", matching the file Salesforce attaches; else the
 * proposal's own name; else "Proposal".
 *
 * @param doc - The proposal document being printed.
 * @returns The title.
 */
export function printDocumentTitle(doc: Pick<DocumentV3, 'name' | 'data'>): string {
  const data: unknown = doc.data;
  const client = data !== null && typeof data === 'object' ? (data as Record<string, unknown>)['client'] : undefined;
  const clientName = client !== null && typeof client === 'object' ? text((client as Record<string, unknown>)['name']) : '';
  if (clientName) return `${PRINT_TITLE_PREFIX} ${clientName}`;
  return text(doc.name) || PRINT_TITLE_FALLBACK;
}
